import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class DateService {

	static readonly APP_DATE_TIME_SHORT = 'MMM d, y';

	static readonly APP_DATE_TIME_BOTH = 'MMM d, y, hh:mm a';

	static readonly APP_DATE_TIME_24 = 'MMM d, y, HH:mm';

	static readonly APP_TIME_ONLY = 'HH:mm:ss';

	formatToIST(date: string | Date, format: string = DateService.APP_DATE_TIME_BOTH): string {
		if (!date) return '';
		return formatDate(date, format, 'en-IN', 'Asia/Kolkata');
	}

}